import React, { useEffect, useState } from 'react'
import { IMG } from '../../../../../themes'
import { CheckinToastStyled } from './styles'

const ICONS = {
  success: 'ic_check-green.svg',
  error: 'ic_alert-triangle.svg'
}

const VISIBLE_MS = 5000
const SLIDE_MS = 400

const CheckinToast = ({ type = 'success', title, message, onClose }) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    requestAnimationFrame(() => setIsVisible(true))

    let closeTimer
    const hideTimer = setTimeout(() => {
      setIsVisible(false)
      closeTimer = setTimeout(onClose, SLIDE_MS)
    }, VISIBLE_MS)

    return () => {
      clearTimeout(hideTimer)
      clearTimeout(closeTimer)
    }
  }, [])

  const handleClose = () => {
    setIsVisible(false)
    setTimeout(onClose, SLIDE_MS)
  }

  return (
    <CheckinToastStyled className={isVisible ? 'visible' : ''}>
      <div className='toast-header'>
        <img className='toast-icon' src={IMG[ICONS[type]]} alt={type} />
        <div className='toast-title'>{title}</div>
        <button className='toast-close' onClick={handleClose}>
          <img src={IMG['close-white.svg']} alt='close' />
        </button>
      </div>
      <div className='toast-message'>{message}</div>
    </CheckinToastStyled>
  )
}

export default CheckinToast
